import React, { useState } from 'react'
import { useObserver } from 'mobx-react'
import styled, { useTheme } from 'styled-components'
import useStores from '../../../stores/useStore'
import { colors } from '../../../styles/colors'
import { useTranslation } from 'react-i18next'
import { PenIcon } from '../../Icons/PenIcon'
import EditPointsModal from './EditPointsModal'

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0;

  @media (max-width: 1109px) {
    width: 100%;
    padding: 4px 0 2px;
  }
`
const StyledItemWrapper = styled.div`
  flex: 0 0 auto;
  padding: 0 12px;
  border-right: 1px solid ${colors.gray3};
  &:last-child {
    border-right: none;
  }
  &:first-child {
    padding-left: 0;
  }
`

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0;
  font-size: 11px;
  line-height: 1.3;
  @media (max-width: 567px) {
    flex-wrap: wrap;
    gap: 8px;
    font-size: 10px;
  }
`

const StyledLabel = styled.div`
  text-transform: uppercase;
  font-weight: bold;
  color: ${colors.textColor};
`

const StyledValue = styled.div`
  color: ${(props) => props.theme.primaryColor};
  font-weight: 600;
`
const StyledEditIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  cursor: pointer;
  svg {
    width: 11px;
    height: 11px;
    opacity: 0.5;
    transition: opacity 0.15s;
  }
  &:hover svg {
    opacity: 1;
  }
`
const EmployeeData = (props) => {
  const { productsStore, uiStore } = useStores()
  const targetEmployee = useObserver(() => productsStore.targetEmployee)
  const [showEditPointsModal, setShowEditPointsModal] = useState(false)
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <>
      <StyledContainer {...props}>
        <StyledWrapper showJobFunction={props.showJobFunction}>
          {props.showJobFunction ? (
            <StyledItemWrapper>
              <StyledLabel className='label-color'>{t('Overlay:jobFunction')}</StyledLabel>
              <StyledValue className='value-color'>
                {productsStore.activities[0].displayName}&nbsp;
              </StyledValue>
            </StyledItemWrapper>
          ) : (
            ''
          )}
          <StyledItemWrapper>
            <StyledLabel className='label-color'>{t('OrderSubheader:personalnr')}.</StyledLabel>
            <StyledValue className='value-color'>
              {targetEmployee.personalNr}&nbsp;
            </StyledValue>
          </StyledItemWrapper>
          <StyledItemWrapper>
            <StyledLabel className='label-color'>{t('OrderSubheader:costcenter')}</StyledLabel>
            <StyledValue className='value-color'>
              {targetEmployee.costCenter &&
                targetEmployee.costCenter.displayName}
              &nbsp;
            </StyledValue>
          </StyledItemWrapper>
          <StyledItemWrapper>
            <StyledLabel className='label-color'>{t('OrderSubheader:orgaUnit')}</StyledLabel>
            <StyledValue className='value-color'>
              {targetEmployee.office && targetEmployee.office.displayName}&nbsp;
            </StyledValue>
          </StyledItemWrapper>
          {targetEmployee.points != null ? (
            <StyledItemWrapper>
              <div className='d-flex align-items-center'>
                <div>
                  <StyledLabel className='label-color'>
                    {t('OrderSubheader:accountBallance')}
                  </StyledLabel>
                  <StyledValue className='value-color'>
                    {targetEmployee.points} {t('points')}
                  </StyledValue>
                </div>
                {uiStore.allowChangePoints ? (
                  <StyledEditIconWrapper
                    onClick={() => setShowEditPointsModal((prev) => !prev)}
                  >
                    <PenIcon
                      color={theme.primaryColor}
                      title={t('OrderSubheader:editPoints')}
                    />
                  </StyledEditIconWrapper>
                ) : null}
              </div>
            </StyledItemWrapper>
          ) : (
            ''
          )}
        </StyledWrapper>
      </StyledContainer>
      {showEditPointsModal && (
        <EditPointsModal
          allowReleasePointsChanges={uiStore.allowReleasePointsChanges}
          employeeId={targetEmployee.id}
          points={targetEmployee.points}
          handleClose={() => setShowEditPointsModal(false)}
        />
      )}
    </>
  )
}

export default EmployeeData
